import { useCallback, useState } from "react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import useGlobalContext from "../../../hooks/useGlobalContext.js";
import useRouteName from "../../../hooks/useRouteName.js";
import { setCookie, getCookie } from "@flights/web-api-utils-universal";
function getDismissCookieName(routeName) {
    return routeName === "fly-anywhere" ? "hide_banner_DSA_fa" : "hide_banner_DSA";
}
function isDismissCookieSet(cookieName) {
    if (typeof document === "undefined")
        return false;
    try {
        return Boolean(getCookie(cookieName));
    }
    catch {
        return false;
    }
}
export function useDSABannerController() {
    const routeName = useRouteName();
    const i18n = useI18n();
    const { contentStandardsGuidelines } = useGlobalContext();
    const [dismissedCookie, setDismissedCookie] = useState();
    const cookieName = getDismissCookieName(routeName);
    const onDismiss = useCallback(() => {
        setDismissedCookie(cookieName);
        try {
            setCookie(cookieName, "1", {
                maxAge: "2h",
                path: "/"
            });
        }
        catch (error) { }
    }, [cookieName]);
    if (!contentStandardsGuidelines) {
        return { shouldRender: false };
    }
    return {
        shouldRender: true,
        isHiddenByDismiss: dismissedCookie === cookieName || isDismissCookieSet(cookieName),
        message: contentStandardsGuidelines.message,
        linkUrl: contentStandardsGuidelines.linkUrl,
        linkLabel: contentStandardsGuidelines.linkLabel,
        closeAriaLabel: i18n.trans(t("close")) ?? "",
        onDismiss
    };
}
